<template>
  <div class="authors">
    <b-container fluid="xxl">
      <b-row class="text-center">
        <b-col>
          <input
            class="px-2 py-1 w-100"
            id="search"
            type="text"
            size="sm"
            placeholder="Search scholars"
            @keyup="getSearchResults()"
            autocomplete="off"
            v-model="query"
          />
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col>
          <ul v-if="authors.length" class="results-ul">
            <li v-for="author in authors" :key="author.id">
              <a href="#" @click="selectAuthor($event, author)" v-html="author.name"></a>
            </li>
          </ul>
          <span v-else class="opacity-60">
            <span v-if="query">No results</span>
            <span v-else>Start searching</span>
          </span>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'AuthorAutocomplete',
    props: ['exclude'],
    data() {
      this.$store.state.author.authors = []
      return {
        query: '',
        timer: null
      }
    },
    mounted() {
      this.$store.state.author.authors = []
    },
    computed: {
      ...mapState({
        authors: state => state.author.authors
      }),
      clearQuery(){
        return this.query.replace(/\*/gi, '')
      }
    },
    methods: {
      selectAuthor(event, author){
        event.preventDefault()
        this.$emit('select', author)
        this.$store.state.author.authors = []
        this.query = ''
      },
      getSearchResults(){
        clearTimeout(this.timer)
        // let that = this
        this.timer = setTimeout(() => {
          this.$store.dispatch('searchAuthors', {
            query: this.query.toLowerCase(),
            exclude: (this.exclude ? this.exclude : [])
          })
        }, 400)
      }
    }
  }
</script>
